
import $ from 'jquery';

import 'intersection-observer';
import scrollama from 'scrollama';

import debounce from './util/debounce';
import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        panoSelector: $('.tier--pano .media'),
        devMode: true
    }, options);


    var ele = {
        panos: $(o.panoSelector)
    };


    var internal = {
        name: 'Pano',
        viewportWidth: document.body.clientWidth
    };


    var fn = {
        init: function () {
            if (ele.panos.length < 1) return;

            fn.setupPanos();

            globalelements.win.on('resize', debounce(handlers.resize, 100));
        },

        setupPanos: function () {
            ele.panos.each(function () {
                var pano = $(this);

                pano.data('media', pano.find('img, video').first());
                pano.data('mediaWidth', pano.data('media').width());
                pano.data('scrollama', scrollama());
                pano.data('scrollama').setup({
                    step: pano[0],
                    offset: 0.5,
                    progress: true,
                    threshold: 2
                }).onStepProgress(function (e) {
                    fn.movePano(pano, e.progress);
                });
            });
        },

        resizePanos: function () {
            ele.panos.each(function () {
                var pano = $(this);

                if (pano.data('scrollama')) {
                    pano.data('mediaWidth', pano.data('media').width());
                    pano.data('scrollama').resize();
                }
            });
        },

        movePano: function (pano, progress) {
            var mediaWidth = pano.data('mediaWidth');
            var viewWidth = internal.viewportWidth;

            if (mediaWidth < viewWidth) {
                pano.data('media').css('transform', '');
            } else {
                pano.data('media').css('transform', 'translate3d(' + helpers.percentolator(0, viewWidth - mediaWidth, progress) + 'px, 0, 0)');
            }
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: intrn.name + '.js',
                prefixColor: 'yellow'
            });
        }
    };


    var handlers = {
        resize: function () {
            internal.viewportWidth = document.body.clientWidth;

            fn.resizePanos();
        }
    };


    var helpers = {
        percentolator: function (begin, end, percent) {
            return begin + (end - begin) * percent;
        }
    };


    fn.init();
}
